module.exports = __webpack_public_path__ + "static/whichCat-f3fcf311c907a06cb368159ad571e925.png";